import React from 'react';

import type { StatusTone } from '~shared/ui/status-badge';
import { StatusBadge } from '~shared/ui/status-badge';

import type { ApplicationStatus } from '../../model/application';

type Props = {
  status: ApplicationStatus;
};

const statusConfig: Record<
  ApplicationStatus,
  { tone: StatusTone; label: string }
> = {
  WAITING_DOWN_PAYMENT: { tone: 'warning', label: 'Down payment required' },
  WAITING_DISBURSEMENT: { tone: 'warning', label: 'Waiting disbursement' },
  SUCCESS: { tone: 'positive', label: 'Success' },
};

export const ApplicationStatusUI = React.memo<Props>(({ status }) => {
  const config = statusConfig[status] as
    | { tone: StatusTone; label: string }
    | undefined;
  const { tone, label } = config ?? { tone: 'neutral', label: status };

  return <StatusBadge tone={tone}>{label}</StatusBadge>;
});
ApplicationStatusUI.displayName = 'ApplicationStatusUI';
